import MaterialTable from 'material-table';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import Service from '../config/networkutils';
import { getCookie } from '../utils/CookieHelper';
import Users from '../components/Users/Users';
import { getDataIsdeletedFalse } from '../components/Helper/CommonThings';

const token = getCookie("ptd_ts_token");
const user = JSON.parse(getCookie("ptd_ts_user"));

class SubContractor extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            isLoading: true,
            userAccess: props.userAccess ? props.userAccess : {},
        }
    }

    componentDidMount() {
        this.fetchSubContractor();

    }

    fetchSubContractor = () => {
        this.setState({ isLoading: true })
        Service.get('/api/subcontractor/get_subcontractor/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                this.setState({ data: resData, isLoading: false })
            })
            .catch(error => {
                console.log(error)
                if(error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                }else{
                     this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                }
            })
    }

    postSubContractor = (data) => {
        if (!data.name) {
            this.props.enqueueSnackbar('Name cannot be Empty', {
                variant: 'warning'
            });
            this.fetchSubContractor();
        } else {
            data.created_by = user.id
            Service.post('/api/subcontractor/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data,
            })
                .then(res => {
                    this.fetchSubContractor();
                    this.props.enqueueSnackbar('External added successfully', {
                        variant: 'success'
                    });
                })
                .catch(error => {
                    console.log(error)
                    this.fetchSubContractor();
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                })
        }
    }

    putSubContractor = (data) => {
        if (!data.name) {
            this.props.enqueueSnackbar('Name cannot be Empty', {
                variant: 'warning'
            });
            this.fetchSubContractor();
        } else {
            Service.put('/api/subcontractor/' + data.id + "/", {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data
            }).then(res => {
                // this.fetchSubContractor();
                this.props.enqueueSnackbar('External edited successfully', {
                    variant: 'success'
                });
            }).catch(error => {
                console.log(error)
                this.fetchSubContractor();
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
        }
    }

    deleteSubContractor = (data) => {
        Service.delete('/api/subcontractor/' + data.id + "/", {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            // this.fetchSubContractor();
            this.props.enqueueSnackbar('External deleted successfully', {
                variant: 'success'
            });
        }
        ).catch(error => {
            console.log(error)
            this.fetchSubContractor();
            this.props.enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            });
        })
    }

    render() {
        return (
            <div>
                <MaterialTable
                    title="External"
                    columns={[
                        { title: 'Name', field: 'name' },
                        { title: 'Description', field: 'description' },
                    ]}
                    data={this.state.data}
                    isLoading={this.state.isLoading}
                    options={{
                        paging: false,
                        padding: 'dense',
                        addRowPosition: 'first',
                    }}
                    editable={{
                        onRowAdd: newData =>
                            new Promise(resolve => {
                                setTimeout(() => {
                                    resolve();
                                    this.setState(prevState => {
                                        const data = [...prevState.data];
                                        this.postSubContractor(newData);
                                        data.push(newData);
                                        return { ...prevState, data };
                                    });
                                }, 600);
                            }),
                        onRowUpdate: (newData, oldData) =>
                            new Promise(resolve => {
                                setTimeout(() => {
                                    resolve();
                                    if (oldData) {
                                        this.setState(prevState => {
                                            const data = [...prevState.data];
                                            data[data.indexOf(oldData)] = newData;
                                            this.putSubContractor(newData)
                                            return { ...prevState, data };
                                        });
                                    }
                                }, 600);
                            }),
                        onRowDelete: oldData =>
                            new Promise(resolve => {
                                setTimeout(() => {
                                    resolve();
                                    // this.setState({ saved: false });
                                    this.setState(prevState => {
                                        const data = [...prevState.data];
                                        data.splice(data.indexOf(oldData), 1);
                                        this.deleteSubContractor(oldData)
                                        return { ...prevState, data };
                                    });
                                }, 600);
                            }),
                    }}
                    detailPanel={rowData => {
                        return (
                            <div>
                                <Users isExternal={true} access={this.state.userAccess} subcontractor={rowData} businessUnit={true} link={false} />
                            </div>
                        )
                    }}
                    onRowClick={(event, rowData, togglePanel) => togglePanel()}
                />
            </div>
        );
    }
}

export default withSnackbar(SubContractor);